import React, { useState } from 'react'
import {
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_ONE_TIME_PASSCODE,
} from '../Helpers/LoginHelper.js'

export default function VerifyPhoneNumber({
  handleDisplayChange,
  phoneNumber,
  newPhoneNumber,
  loginInputHook,
  passwordInputHook,
}) {
  const [loginInput] = loginInputHook ? loginInputHook : [null]
  const [passwordInput] = passwordInputHook ? passwordInputHook : [null]
  const [choice, setChoice] = useState('text-code-to-phone-number')

  const onChoiceChange = (event) => {
    setChoice(event.target.value)
  }

  const onCancelledClicked = () => {
    handleDisplayChange(FORM_NAME_LOGIN_FORM)
  }

  const onNextClicked = async () => {
    let data = {
      updateUsrContact: {
        emailId: loginInput,
        password: passwordInput,
        deviceSignature: window?.getDeviceSignature(),
        channel: choice === 'text-code-to-phone-number' ? 'SMS' : 'IVR',
        isNewPhnNbr: newPhoneNumber,
      },
    }

    if (newPhoneNumber) {
      data.updateUsrContact.usrVerifyPhoneNbr = phoneNumber.replace(/\D/g, '')
    }

    handleDisplayChange(FORM_NAME_ONE_TIME_PASSCODE, data)
  }

  return (
    <div className="u-sizeFull u-lg-size1of2 u-marginBottom6gu Content">
      <h2 className="u-marginBottom2gu u-marginTop0">
        Help us keep your account more secure
      </h2>
      <p className="u-marginBottom6gu">Verify your identity.</p>
      <div className="Radio u-flexCol">
        <input
          onChange={onChoiceChange}
          className="Radio-button u-marginLeft0"
          id="text-code-to-phone-number"
          type="radio"
          value="text-code-to-phone-number"
          name="text-code-radio"
          checked={choice === 'text-code-to-phone-number'}
        />
        <label
          htmlFor="text-code-to-phone-number"
          className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
        >
          Text a code to: XXX.XXX.{phoneNumber.slice(-4)}
        </label>
        <input
          onChange={onChoiceChange}
          className="Radio-button u-marginLeft0"
          id="call-code-to-phone-number"
          type="radio"
          value="call-code-to-phone-number"
          name="call-code-radio"
          checked={choice === 'call-code-to-phone-number'}
        />
        <label
          htmlFor="call-code-to-phone-number"
          className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
        >
          Call me with a code at: XXX.XXX.{phoneNumber.slice(-4)}
        </label>
      </div>

      <div className="u-flex">
        <div className="u-flex u-paddingTop4gu">
          <button
            onClick={onNextClicked}
            className="Button Button--primary  Button--block u-marginRight5gu u-textNoTransform u-flex1of2"
          >
            Next
          </button>
          <button
            onClick={onCancelledClicked}
            className="Button Button--tertiary Button--block u-textNoTransform u-flex1of2"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
